__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "idea-builder-frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@optiaxiom/globals", "3.0.1", () => (Promise.all([__webpack_require__.e(995), __webpack_require__.e(554)]).then(() => (() => (__webpack_require__(8554))))));
			register("@radix-ui/react-dismissable-layer", "1.1.11", () => (Promise.all([__webpack_require__.e(995), __webpack_require__.e(717), __webpack_require__.e(309)]).then(() => (() => (__webpack_require__(7309))))));
			register("@radix-ui/react-focus-scope", "1.1.7", () => (Promise.all([__webpack_require__.e(995), __webpack_require__.e(717), __webpack_require__.e(425)]).then(() => (() => (__webpack_require__(7806))))));
			register("@radix-ui/react-focus-scope", "1.1.7", () => (Promise.all([__webpack_require__.e(995), __webpack_require__.e(717), __webpack_require__.e(15)]).then(() => (() => (__webpack_require__(3015))))));
			register("@radix-ui/react-focus-scope", "1.1.7", () => (Promise.all([__webpack_require__.e(995), __webpack_require__.e(717), __webpack_require__.e(670)]).then(() => (() => (__webpack_require__(5670))))));
			register("@radix-ui/react-focus-scope", "1.1.8", () => (Promise.all([__webpack_require__.e(995), __webpack_require__.e(717), __webpack_require__.e(531)]).then(() => (() => (__webpack_require__(8531))))));
			register("@tanstack/react-query", "4.43.0", () => (Promise.all([__webpack_require__.e(460), __webpack_require__.e(995), __webpack_require__.e(888)]).then(() => (() => (__webpack_require__(2460))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(995), __webpack_require__.e(228)]).then(() => (() => (__webpack_require__(961))))));
			register("react", "17.0.2", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
			register("zustand", "4.5.7", () => (Promise.all([__webpack_require__.e(995), __webpack_require__.e(621)]).then(() => (() => (__webpack_require__(1621))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};